import "./labelButton.css";

export const LabelButton = ({ children }) => {
  return (
    <a href className="label-button body3">
      <span>
        <div></div>
        {children}
      </span>
    </a>
  );
};
